import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, appConfig).then(async () => {
  const AOS = await import('aos');
  AOS.default.init({
    duration: 600,
    easing: 'ease-in-out',
    once: true,
    mirror: false
  });
}).catch((err) => console.error(err));
